<template>
  <div class="container ingreso-manual">
    <div class="header">
      <div id="navigation-back" @click.prevent="back">
        <figure id="back-figure">
          <img src="../../static/img/back.png" alt="Volver">
        </figure>
      </div>
      <div id="navigation-home" @click.prevent="goInicio">
        <figure id="home-figure">
            <img src="../../static/img/home.png" alt="Inicio">
        </figure>
      </div>
    </div>
    <div class="section">
      <div class="logo">
        <figure>
          <img src="../assets/logo.png" alt="DIRECTV">
        </figure>
      </div>
      <div id="seleccionarSexo">
        <a id="M" @click.prevent="save">
          <div>
            <p>M</p>
            <p>Masculino</p>
          </div>
        </a>
        <a id="F" @click.prevent="save">
          <div>
            <p>F</p>
            <p>Femenino</p>
          </div>
        </a>
        <a id="X" @click.prevent="save">
          <div>
            <p>X</p>
            <p id="noBinario">Otros</p>
          </div>
        </a>
      </div>
    </div>
    <b-alert
      v-model="error"
      variant= "warning">
      <p>{{ errorMessage }}</p>
    </b-alert>    
  </div>
</template>

<script>

export default {
  data () {
    return {
      error: false,
      errorMessage: ''
    }
  },
  created () {
    if (!this.$store.getters['settings/testing']) {
      if (!this.$store.getters['user/loggedIn']) {
        this.$router.push({ name: 'Login' });
      }

      this.evento = this.$store.getters['eventos/evento'];
      if (this.evento) {
        this.eventoNombre = this.evento.nombre;
      }
      if (!this.evento) {
        this.$router.push({ name: 'SeleccionEvento' });
      }
    }
  },
  methods: {
    save (event) {
      var sexo = '';
      
      if (event) {
        sexo = event.target.innerHTML;
      }

      if ( sexo.trim() != '' ) {
        this.$store.dispatch('participante/setSexoParticipante', sexo)
          .then(() => this.$router.push({ name: 'IngresoEsCliente' }))
          .catch( error => {
            this.error = true;
            this.errorMessage = error;
          });
      }
    },
    back () {
      this.$router.go(-1)
    },
    goInicio () {
      this.$router.push({ name: 'Inicio' });
    },
  },
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/IngresoManualSexo.vue